const baseStyle = {};
const defaultProps = {
  ratio: 4 / 3
};
export default {
  baseStyle,
  defaultProps
};
//# sourceMappingURL=aspect-ratio.js.map